import './ReviewStack.css'
import DesignCard from './DesignCard';

import { Rating } from '@smastrom/react-rating'
import '@smastrom/react-rating/style.css'
import { useEffect, useState } from 'react';

const ReviewCard = (props) => {
    const [rating, setRating] = useState(0);
    const [vibe, setVibe] = useState('');
    const [active, setActive] = useState(false);

    useEffect(() => {
        if (rating > 0 && vibe.length > 3 && vibe.length < 11)
            setActive(true);
        else
            setActive(false)
    }, [rating, vibe])
    return (
        <div className='stack_center'>
            <div className='stack_design'>
                {props.design &&
                    <DesignCard design={props.design} />
                }
            </div>
            <div className='stack_rate'>
                <input
                    // type="text"
                    // id="text-input"
                    className='stack_input'
                    value={vibe}
                    onChange={(event) => setVibe(event.target.value)}
                    placeholder="Vibe"
                />
                <div className='stack_stars'>
                    <Rating value={rating} onChange={setRating} />
                </div>
            </div>
            <div
                className='stack_btn'
                style={{
                    color: active ? '#FFFFFF' : 'grey',
                    backgroundColor: active ? '#605678' : '#FFFFFF'
                }}
                onClick={() => {
                    if (active) {
                        setVibe('');
                        setRating('');
                        props.send(vibe, rating, props.design.id)
                    }
                }}
            >Send</div>
        </div>
    )
}

export default ReviewCard;